import { render, staticRenderFns } from "./playersList.vue?vue&type=template&id=8647a252&"
import script from "./playersList.vue?vue&type=script&lang=js&"
export * from "./playersList.vue?vue&type=script&lang=js&"
import style0 from "./playersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports